<template>
    <div class="base">
      <div class='top'></div>
      <div class="bodyText" v-html="html" >
       
      </div>
      <div class="bottom-img">
        <img src="../assets/image/bottom.png" style="height:1.2rem;" />
      </div>
    </div>
</template>

<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'
export default {
  name: '', // 小镇基本情况
  data () {
    return {
      html: ''
    }
  },
  created: function () {
    document.title = '周边介绍'
    var params = {
      townId: api.getVal('townId')
    }
    api.GetTownInfo(params)
      .then(res => {
        this.html = res.communityRemark
      })
  },
  methods: {
  }
}
</script>


<style scoped>
  .base{
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
  }
  .top{
    flex:0 0 .25rem;
    background-color: #ebebeb;
  }
  .bodyText{
    flex:1;
    background-color: #fff;
    margin: .75rem .75rem  2.25rem .75rem;

  }
  .bodyText p {
    display: block;
    width: 100%;
    line-height: 1.2rem;
    padding-bottom: .75rem;
  }
  .bodyText img{
     width:100%;
     border-radius: .2rem;
  }
  .bottom-img{
    flex: 0 0 2.5rem;
    display: flex;
    background-color: #fff;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// base.vue?b543ad08